// <cart-drawer>: open/close, line changes via /cart/change.js with Section
// Rendering (sections: "cart-drawer"), badge sync via theme.updateCartCount.
customElements.define(
  "cart-drawer",
  class extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", (e) => {
        if (e.target.closest("[data-drawer-close]") || e.target.matches("[data-drawer-scrim]")) this.close();
        const btn = e.target.closest("[data-qty-change]");
        if (btn) this.changeLine(Number(btn.dataset.line), Number(btn.dataset.qty));
      });
      document.addEventListener("cart:open", () => this.open());
      document.addEventListener("cart:refresh", (e) => this.renderSection(e.detail.sections));
      document.addEventListener("keydown", (e) => e.key === "Escape" && this.close());
      document.querySelectorAll("[data-cart-toggle]").forEach((a) =>
        a.addEventListener("click", (e) => { e.preventDefault(); this.open(); })
      );
    }
    open() {
      this.classList.add("is-open");
      this.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      this._release = window.theme.trapFocus(this);
    }
    close() {
      this.classList.remove("is-open");
      this.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (this._release) { this._release(); this._release = null; }
    }
    async changeLine(line, quantity) {
      // Taken before the skeleton below wipes the lines, so a price drop has a figure to
      // count down from.
      const before = window.theme.priceDrop && window.theme.priceDrop.snapshot(this);
      const lines = this.querySelector("[data-cart-lines]");
      const content = this.querySelector("#cart-drawer-content");
      if (content) content.setAttribute("aria-busy", "true");
      if (lines) lines.innerHTML = window.theme.skeleton("cart-item", Math.max(lines.children.length || 2, 1));
      try {
        const data = await window.theme.postJson(window.routes.cart_change_url + ".js", {
          line, quantity, sections: "cart-drawer",
        });
        this.renderSection(data.sections, before);
      } catch {
        if (content) content.setAttribute("aria-busy", "false");
        window.theme.toast(window.theme.strings.cartError, { type: "error" });
      }
    }
    renderSection(sections, before) {
      const pd = window.theme.priceDrop;
      const wasOpen = this.classList.contains("is-open");
      // An add-to-cart arrives here with the old lines still on screen, so they are the
      // "before"; a quantity change hands its own, taken ahead of the skeleton.
      if (pd && !before) before = pd.snapshot(this);
      const fresh = window.theme.sectionNode(sections && sections["cart-drawer"], "#cart-drawer-content");
      const current = this.querySelector("#cart-drawer-content");
      if (fresh && current) current.replaceWith(fresh);
      window.theme.updateCartCount(fresh ? fresh.dataset.itemCount : "0");
      // After an add-to-cart the drawer is still closed and about to slide in (0.2s), so
      // the count waits for it instead of finishing off-screen.
      if (pd && fresh && current) pd.play(fresh, before, { delay: wasOpen ? 0 : 250 });
    }
  }
);
